import React from "react";
import {pieLabels} from "../../svgs/tokenomics/pieLabels";

export default function PieLabels() {
  return (
    <>
      <div className="absolute top-1 -left-[45%] ">
        <img src={pieLabels.pl1} alt="l" />{" "}
      </div>
      <div className="absolute -top-6 -left-[45%]">
        <span className="font-semibold text-lg">Partnership</span>
        <br />
        5%
      </div>

      <div className="absolute top-12 -left-[50%] ">
        <img className="" src={pieLabels.pl2} alt="l" />{" "}
      </div>
      <div className="absolute top-[46px] -left-[44.5%]">
        <span className="font-semibold text-lg">Marketing</span>
        <br />
        3% &nbsp;
        <span className="text-xs">locked 6 months, released 1% yearly</span>
      </div>

      <div className="absolute top-[88px] -left-[50%] ">
        <img className="" src={pieLabels.pl3} alt="l" />{" "}
      </div>
      <div className="absolute top-28 -left-[44.5%]">
        <span className="font-semibold text-lg">Development</span>
        <br />
        4% &nbsp;
        <span className="text-xs">locked 1 year, released 1% yearly</span>
      </div>

      <div className="absolute top-44 -left-[50%] ">
        <img className="" src={pieLabels.pl4} alt="l" />{" "}
      </div>
      <div className="absolute top-44 -left-[44.5%]">
        <span className="font-semibold text-lg">Exchange and MM</span>
        <br />
        12.8%
      </div>

      <div className="absolute top-64 -left-[50%] ">
        <img className="" src={pieLabels.pl5} alt="l" />{" "}
      </div>
      <div className="absolute top-[252px] -left-[44.5%]">
        <span className="font-semibold text-lg">Game Ecosystem</span>
        <br />
        14%
      </div>

      <div className="absolute -top-44 -right-[95%] ">
        <img className="" src={pieLabels.pr1} alt="l" />{" "}
      </div>
      <div className="absolute -top-1.5 text-right -right-[42%]">
        <span className="font-semibold text-base">Team</span>
        <br />
        <span className="text-xs">locked 6 months, released 1% yearly</span>
        &nbsp; 3%
      </div>
      <div className="absolute text-[10px] -top-24 -right-[330px]">
        Presale (Pink sale)
        <br />
        No private sale
        <br />
        No max wallet
        <br />
        No max tx
        <br />
        Supply: 10,000,000
      </div>

      <div className="absolute top-20 -right-[48%]">
        <img className="" src={pieLabels.pr2} alt="l" />{" "}
      </div>
      <div className="absolute top-[78px] text-right -right-[42%]">
        <span className="font-semibold text-lg">Presale</span>
        <br /> 20%
      </div>

      <div className="absolute top-48 -right-[48%]">
        <img className="" src={pieLabels.pr3} alt="l" />{" "}
      </div>
      <div className="absolute top-48 text-right -right-[42%]">
        <span className="font-semibold text-lg">LP</span>
        <br /> 10.2%
      </div>

      <div className="absolute top-80 -right-[48%]">
        <img className="" src={pieLabels.pr4} alt="l" />{" "}
      </div>
      <div className="absolute top-[346px] text-right -right-[42%]">
        <span className="font-semibold text-lg">Staking</span>
        <br /> 28%
      </div>
    </>
  );
}
